import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';
import { GuardedRoute } from './guarded-routes';
import { SuspenseLoader } from 'src/shared/components/index';

const Loader = (Component: any) => (props: any) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const Login = Loader(lazy(() => import('src/auth/Login')));
const AssessmentsList = Loader(lazy(() => import('src/modules/Assessments/AssessmentsList')));
const AssessmentDetail = Loader(lazy(() => import('src/modules/Assessments/AssessmentDetail')));
const TopicReport = Loader(lazy(() => import('src/modules/Assessments/TopicReport')));
const ErrorPage = Loader(lazy(() => import('src/modules/ErrorPage/ErrorPage')));

const RootLogin = () => (
  <div style={{padding: 40, textAlign: 'center'}}>
    <h2>snap.assess</h2>
    <p>Please use your tenant-specific login URL.</p>
    <p>Example: /your-tenant-uuid/login</p>
  </div>
);

const routes: RouteObject[] = [
  { path: '/', element: <Navigate to="/login" /> },
  { path: '/login', element: <RootLogin /> },
  { path: '/:tenantId/login', element: <Login /> },
  {
    path: '/:tenantId',
    element: <GuardedRoute />,
    children: [
      { path: 'assessments', element: <AssessmentsList /> },
      { path: 'assessments/:assessmentId', element: <AssessmentDetail /> },
      { path: 'assessments/:assessmentId/topic/:topicId/report', element: <TopicReport /> },
    ],
  },
  { path: '*', element: <ErrorPage /> },
];

export default routes;
